import { IMemberClientForm1099Balances } from "@wingspanhq/payments/dist/interfaces";

export const selectorIsForm1099BalanceSubmitted = (
  form1099Balance?: IMemberClientForm1099Balances
) => Boolean(form1099Balance?.taxForm?.submissions?.[0]?.events?.submittedAt);
